import { useEffect } from 'react';

export default function PoliticaPrivacidade() {
  useEffect(() => {
    document.title = 'Política de Privacidade - Cirurgia Autorizada';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="px-6 py-8 sm:px-10">
            <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              Política de Privacidade
            </h1>
            
            <div className="prose max-w-none text-gray-700 leading-relaxed">
              <p className="mb-6">
                Na Plataforma Cirurgia Autorizada, privacidade e segurança são prioridades e nos comprometemos com a transparência do tratamento de dados pessoais dos nossos usuários/clientes. Por isso, esta presente Política de Privacidade estabelece como é feita a coleta, uso e transferência de informações de clientes ou outras pessoas que acessam ou usam nosso site.
              </p>

              <p className="mb-6">
                Ao utilizar nossos serviços, você entende que coletaremos e usaremos suas informações pessoais nas formas descritas nesta Política, sob as normas de Proteção de Dados (LGPD, Lei Federal 13.709/2018), das disposições consumeristas da Lei Federal 8078/1990 e as demais normas do ordenamento jurídico brasileiro aplicáveis.
              </p>

              <p className="mb-8">
                Dessa forma, a Cirurgia Autorizada, doravante denominada simplesmente como "Plataforma Cirurgia Autorizada", inscrita em nome de Luiz Holanda Pinto Neto com CPF sob o nº 638.431.453-34, no papel de Controladora de Dados, obriga-se ao disposto na presente Política de Privacidade.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">1. Quais dados coletamos sobre você e para qual finalidade?</h2>
              
              <p className="mb-6">
                Nosso site coleta e utiliza alguns dados pessoais seus, de forma a viabilizar a prestação de serviços e aprimorar a experiência de uso.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">1.1 Dados pessoais fornecidos pelo titular</h3>

              <p className="mb-4">
                <strong>1.1.1. Paciente:</strong> nome completo, data de nascimento, sexo, telefone, whatsapp, email, dados de responsável (se necessário), nome do cirurgião, intervalo de datas desejável para cirurgia, pré-operatório, existência de alergias e dados de autorização do procedimento cirúrgico. Todos esses dados são necessários no processo de agendamento cirúrgico, sendo necessários para procedimento de identificação junto ao hospital e identidade única do processo.
              </p>

              <p className="mb-4">
                <strong>1.1.2. Cirurgião:</strong> Nome, CRM, CPF como dados de identificação do médico, endereço, telefone e whatsapp, email e senha. Se possui secretária(o). Dados para verificação e confirmação de veracidade dos dados, além de contatos necessários durante o processo.
              </p>

              <p className="mb-4">
                <strong>1.1.3. Secretário(a):</strong> Nome, telefone, whatsapp, email e senha como dados para acesso ao portal e contato necessário.
              </p>

              <p className="mb-6">
                <strong>1.1.4. Fornecedor de Material:</strong> razão social, nome fantasia, CNPJ, endereço, telefone, whatsapp, email e pessoa de contato. Dados necessário para verificação de veracidade de cadastro.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">1.2 Dados pessoais coletados automaticamente</h3>

              <p className="mb-8">
                Data e Hora das operações; Estas são necessárias para a organização de "timeline" dos eventos cronológicos para a ação da plataforma de organização.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">2. Como coletamos os seus dados?</h2>
              
              <p className="mb-4">
                Nesse sentido, a coleta dos seus dados pessoais ocorre da seguinte forma:
              </p>

              <p className="mb-6">
                Através de informação incluídas pelos próprios usuários pelos meios de Portal Web (https://www.cirurgiaautorizada.com.br) e Aplicativo móvel (Cirurgia Autorizada).
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.1 Consentimento</h3>

              <p className="mb-4">
                É a partir do seu consentimento que tratamos os seus dados pessoais. O consentimento é a manifestação livre, informada e inequívoca pela qual você autoriza a Plataforma Cirurgia Autorizada a tratar seus dados.
              </p>

              <p className="mb-4">
                Assim, em consonância com a Lei Geral de Proteção de Dados, seus dados só serão coletados, tratados e armazenados mediante prévio e expresso consentimento.
              </p>

              <p className="mb-4">
                O seu consentimento será obtido de forma específica para cada finalidade acima descrita, evidenciando o compromisso de transparência e boa-fé da Plataforma Cirurgia Autorizada para com seus usuários/clientes, seguindo as regulações legislativas pertinentes.
              </p>

              <p className="mb-4">
                Ao utilizar os serviços da Plataforma Cirurgia Autorizada e fornecer seus dados pessoais, você está ciente e consentindo com as disposições desta Política de Privacidade, além de conhecer seus direitos e como exercê-los.
              </p>

              <p className="mb-4">
                A qualquer tempo e sem nenhum custo, você poderá revogar seu consentimento.
              </p>

              <p className="mb-8">
                É importante destacar que a revogação do consentimento para o tratamento dos dados pode implicar a impossibilidade da performance adequada de alguma funcionalidade do site e/ou aplicativo que dependa da operação. Tais consequências serão informadas previamente.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">3. Quais são os seus direitos?</h2>

              <p className="mb-4">
                A Plataforma Cirurgia Autorizada assegura a seus usuários/clientes seus direitos de titular previstos no artigo 18 da Lei Geral de Proteção de Dados. Dessa forma, você pode, de maneira gratuita e a qualquer tempo:
              </p>

              <ul className="list-disc ml-6 mb-8 space-y-2">
                <li>Confirmar a existência de tratamento de dados, de maneira simplificada ou em formato claro e completo.</li>
                <li>Acessar seus dados, podendo solicitá-los em uma cópia legível sob forma impressa ou por meio eletrônico, seguro e idôneo.</li>
                <li>Corrigir seus dados, ao solicitar a edição, correção ou atualização destes.</li>
                <li>Limitar seus dados quando desnecessários, excessivos ou tratados em desconformidade com a legislação através da anonimização, bloqueio ou eliminação.</li>
                <li>Solicitar a portabilidade de seus dados, através de um relatório de dados cadastrais que a Plataforma Cirurgia Autorizada trata a seu respeito.</li>
                <li>Eliminar seus dados tratados a partir de seu consentimento, exceto nos casos previstos em lei.</li>
                <li>Revogar seu consentimento, desautorizando o tratamento de seus dados.</li>
                <li>Informar-se sobre a possibilidade de não fornecer seu consentimento e sobre as consequências da negativa.</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">4. Como você pode exercer seus direitos de titular?</h2>

              <p className="mb-4">
                Para exercer seus direitos de titular, você deve entrar em contato com a Plataforma Cirurgia Autorizada através dos seguintes meios disponíveis:
              </p>

              <p className="mb-4">
                <strong>E-mail:</strong> contato@cirurgiaautorizada.com.br
              </p>

              <p className="mb-8">
                De forma a garantir a sua correta identificação como titular dos dados pessoais objeto da solicitação, é possível que solicitemos documentos ou demais comprovações que possam comprovar sua identidade. Nessa hipótese, você será informado previamente.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">5. Como e por quanto tempo seus dados serão armazenados?</h2>

              <p className="mb-4">
                Seus dados pessoais coletados pela Plataforma Cirurgia Autorizada serão utilizados e armazenados durante o tempo necessário para a prestação do serviço ou para que as finalidades elencadas na presente Política de Privacidade sejam atingidas, considerando os direitos dos titulares dos dados e dos controladores.
              </p>

              <p className="mb-4">
                De modo geral, seus dados serão mantidos enquanto a relação contratual entre você e a Plataforma Cirurgia Autorizada perdurar. Findado o período de armazenamento dos dados pessoais, estes serão excluídos de nossas bases de dados ou anonimizados, ressalvadas as hipóteses legalmente previstas no artigo 16 lei geral de proteção de dados, a saber:
              </p>

              <ul className="list-disc ml-6 mb-4 space-y-2">
                <li><strong>I</strong> – cumprimento de obrigação legal ou regulatória pelo controlador;</li>
                <li><strong>II</strong> – estudo por órgão de pesquisa, garantida, sempre que possível, a anonimização dos dados pessoais;</li>
                <li><strong>III</strong> – transferência a terceiro, desde que respeitados os requisitos de tratamento de dados dispostos nesta Lei; ou</li>
                <li><strong>IV</strong> – uso exclusivo do controlador, vedado seu acesso por terceiro, e desde que anonimizados os dados.</li>
              </ul>

              <p className="mb-4">
                Isto é, informações pessoais sobre você que sejam imprescindíveis para o cumprimento de determinações legais, judiciais e administrativas e/ou para o exercício do direito de defesa em processos judiciais e administrativos serão mantidas, a despeito da exclusão dos demais dados.
              </p>

              <p className="mb-8">
                O armazenamento de dados coletados pela Plataforma Cirurgia Autorizada reflete o nosso compromisso com a segurança e privacidade dos seus dados. Empregamos medidas e soluções técnicas de proteção aptas a garantir a confidencialidade, integridade e inviolabilidade dos seus dados. Além disso, também contamos com medidas de segurança apropriadas aos riscos e com controle de acesso às informações armazenadas.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">6. O que fazemos para manter seus dados seguros?</h2>

              <p className="mb-4">
                Para mantermos suas informações pessoais seguras, usamos ferramentas físicas, eletrônicas e gerenciais orientadas para a proteção da sua privacidade.
              </p>

              <p className="mb-4">
                Aplicamos essas ferramentas levando em consideração a natureza dos dados pessoais coletados, o contexto e a finalidade do tratamento e os riscos que eventuais violações gerariam para os direitos e liberdades do titular dos dados coletados e tratados.
              </p>

              <p className="mb-4">
                Entre as medidas que adotamos, destacamos as seguintes:
              </p>

              <ul className="list-disc ml-6 mb-4 space-y-2">
                <li>Apenas pessoas autorizadas têm acesso a seus dados pessoais</li>
                <li>O acesso a seus dados pessoais é feito somente após o compromisso de confidencialidade</li>
                <li>Seus dados pessoais são armazenados em ambiente seguro e idôneo.</li>
              </ul>

              <p className="mb-4">
                A Plataforma Cirurgia Autorizada se compromete a adotar as melhores posturas para evitar incidentes de segurança. Contudo, é necessário destacar que nenhuma página virtual é inteiramente segura e livre de riscos. É possível que, apesar de todos os nossos protocolos de segurança, problemas de culpa exclusivamente de terceiros ocorram, como ataques cibernéticos de hackers, ou também em decorrência da negligência ou imprudência do próprio usuário/cliente.
              </p>

              <p className="mb-8">
                Em caso de incidentes de segurança que possa gerar risco ou dano relevante para você ou qualquer um de nossos usuários/clientes, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido, em consonância com as disposições da Lei Geral de Proteção de Dados.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">7. Com quem seus dados podem ser compartilhados?</h2>
              
              <p className="mb-4">
                Tendo em vista a preservação de sua privacidade, a Plataforma Cirurgia Autorizada não compartilhará seus dados pessoais com nenhum terceiro não autorizado.
              </p>

              <p className="mb-4">
                Seus dados poderão ser compartilhados com nossos parceiros comerciais: SOFTBUILDER INFORMATICA LTDA EPP, inscrito no CPF/CNPJ sob o nº 02.165.859/0001-86.
              </p>

              <p className="mb-4">
                Estes recebem seus dados apenas na medida do necessário para a prestação dos serviços contratados e nossos contratos são orientados pelas normas de proteção de dados do ordenamento jurídico brasileiro.
              </p>

              <p className="mb-4">
                Todavia, nossos parceiros têm suas próprias Políticas de Privacidade, que podem divergir desta. Recomendamos a leitura desses documentos, que você pode acessar aqui:
              </p>

              <p className="mb-4">
                Política de Privacidade do nosso parceiro: (link para a política de privacidade do parceiro comercial).
              </p>

              <p className="mb-4">
                Além disso, também existem outras hipóteses em que seus dados poderão ser compartilhados, que são:
              </p>

              <ul className="list-disc ml-6 mb-6 space-y-2">
                <li><strong>I</strong> – Determinação legal, requerimento, requisição ou ordem judicial, com autoridades judiciais, administrativas ou governamentais competentes.</li>
                <li><strong>II</strong> – Caso de movimentações societárias, como fusão, aquisição e incorporação, de forma automática</li>
                <li><strong>III</strong> – Proteção dos direitos da Plataforma Cirurgia Autorizada em qualquer tipo de conflito, inclusive os de teor judicial.</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">7.1 Transferência internacional de dados</h3>

              <p className="mb-4">
                Alguns dos terceiros com quem compartilhamos seus dados podem ser localizados ou ou possuir instalações localizadas em países estrangeiros. Nessas condições, de toda forma, seus dados pessoais estarão sujeitos à Lei Geral de Proteção de Dados e às demais legislações brasileiras de proteção de dados.
              </p>

              <p className="mb-4">
                Nesse sentido, a Plataforma Cirurgia Autorizada se compromete a sempre adotar eficientes padrões de segurança cibernética e de proteção de dados, nos melhores esforços de garantir e cumprir as exigências legislativas.
              </p>

              <p className="mb-8">
                Ao concordar com essa Política de Privacidade, você concorda com esse compartilhamento, que se dará conforme as finalidades descritas no presente instrumento.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">8. Cookies ou dados de navegação</h2>

              <p className="mb-4">
                A Plataforma Cirurgia Autorizada faz uso de Cookies, que são arquivos de texto enviados pela plataforma ao seu computador e que nele se armazenam, que contém informações relacionadas à navegação do site. Em suma, os Cookies são utilizados para aprimorar a experiência de uso.
              </p>

              <p className="mb-4">
                Ao acessar nosso site e consentir com o uso de Cookies, você manifesta conhecer e aceitar a utilização de um sistema de coleta de dados de navegação com o uso de Cookies em seu dispositivo.
              </p>

              <p className="mb-4">
                A Plataforma Cirurgia Autorizada utiliza os seguintes Cookies: (descrição dos tipos de Cookies utilizados pelo site).
              </p>

              <p className="mb-4">
                Você pode, a qualquer tempo e sem nenhum custo, alterar as permissões, bloquear ou recusar os Cookies. Todavia, a revogação do consentimento de determinados Cookies pode inviabilizar o funcionamento correto de alguns recursos da plataforma.
              </p>

              <p className="mb-4">
                Para gerenciar os cookies do seu navegador, basta fazê-lo diretamente nas configurações do navegador, na área de gestão de Cookies. Você pode acessar tutoriais sobre o tema diretamente nos links abaixo:
              </p>

              <ul className="list-disc ml-6 mb-8 space-y-2">
                <li>Se você usa o Internet Explorer.</li>
                <li>Se você usa o Firefox.</li>
                <li>Se você usa o Safari.</li>
                <li>Se você usa o Google Chrome.</li>
                <li>Se você usa o Microsoft Edge.</li>
                <li>Se você usa o Opera.</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">9. Alteração desta Política de Privacidade</h2>
              
              <p className="mb-4">
                A atual versão da Política de Privacidade foi formulada e atualizada pela última vez em: 14 de março de 2021.
              </p>

              <p className="mb-4">
                Reservamos o direito de modificar essa Política de Privacidade a qualquer tempo, principalmente em função da adequação a eventuais alterações feitas em nosso site ou em âmbito legislativo. Recomendamos que você a revise com frequência.
              </p>

              <p className="mb-4">
                Eventuais alterações entrarão em vigor a partir de sua publicação em nosso site e sempre lhe notificaremos acerca das mudanças ocorridas.
              </p>

              <p className="mb-8">
                Ao utilizar nossos serviços e fornecer seus dados pessoais após tais modificações, você as consente.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">10. Responsabilidade</h2>
              
              <p className="mb-4">
                A Plataforma Cirurgia Autorizada prevê a responsabilidade dos agentes que atuam nos processos de tratamento de dados, em conformidade com os artigos 42 ao 45 da Lei Geral de Proteção de Dados.
              </p>

              <p className="mb-4">
                Nos comprometemos em manter esta Política de Privacidade atualizada, observando suas disposições e zelando por seu cumprimento.
              </p>

              <p className="mb-4">
                Além disso, também assumimos o compromisso de buscar condições técnicas e organizativas seguramente aptas a proteger todo o processo de tratamento de dados.
              </p>

              <p className="mb-6">
                Caso a Autoridade Nacional de Proteção de Dados exija a adoção de providências em relação ao tratamento de dados realizado pela Plataforma Cirurgia Autorizada, comprometemo-nos a segui-las.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">10.1 Isenção de responsabilidade</h3>

              <p className="mb-4">
                Conforme mencionado no Tópico 6, embora adotemos elevados padrões de segurança a fim de evitar incidentes, não há nenhuma página virtual inteiramente livre de riscos. Nesse sentido, a Plataforma Cirurgia Autorizada não se responsabiliza por:
              </p>

              <p className="mb-4">
                <strong>I</strong> – Quaisquer consequências decorrentes da negligência, imprudência ou imperícia dos usuários em relação a seus dados individuais. Garantimos e nos responsabilizamos apenas pela segurança dos processos de tratamento de dados e do cumprimento das finalidades descritas no presente instrumento.
              </p>

              <p className="mb-4">
                Destacamos que a responsabilidade em relação à confidencialidade dos dados de acesso é do usuário.
              </p>

              <p className="mb-4">
                <strong>II</strong> – Ações maliciosas de terceiros, como ataques de hackers, exceto se comprovada conduta culposa ou deliberada da Plataforma Cirurgia Autorizada.
              </p>

              <p className="mb-4">
                Destacamos que em caso de incidentes de segurança que possam gerar risco ou dano relevante para você ou qualquer um de nossos usuários/clientes, comunicaremos aos afetados e a Autoridade Nacional de Proteção de Dados sobre o ocorrido e cumpriremos as providências necessárias.
              </p>

              <p className="mb-8">
                <strong>III</strong> – Inveracidade das informações inseridas pelo usuário/cliente nos registros necessários para a utilização dos serviços da Plataforma Cirurgia Autorizada; quaisquer consequências decorrentes de informações falsas ou inseridas de má-fé são de inteiramente responsabilidade do usuário/cliente.
              </p>

              <h2 className="text-2xl font-semibold text-gray-900 mb-4 mt-8">11. Encarregado de Proteção de Dados</h2>
              
              <p className="mb-4">
                A Plataforma Cirurgia Autorizada disponibiliza os seguintes meios para que você possa entrar em contato conosco para exercer seus direitos de titular:
              </p>

              <p className="mb-4">
                <strong>E-mail:</strong> luizholanda@cirurgiaautorizada.com.br<br />
                <strong>Correspondência:</strong> Avenida Pontes Vieira, no.2340, Sala 410 - CEP 60.135-238 - Fortaleza - Ceará - Brasil.
              </p>

              <p className="mb-4">
                Caso tenha dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, você pode entrar em contato com o nosso Encarregado de Proteção de Dados Pessoais, através dos seguintes canais:
              </p>

              <p className="mb-4">
                <strong>Luiz Holanda Pinto Neto</strong> - CPF 638.431.453-34<br />
                <strong>E-mail:</strong> luizholanda@cirurgiaautorizada.com.br
              </p>

              <p className="text-center text-gray-600 mt-8 pt-8 border-t border-gray-200">
                <strong>Atualização: 14 de março de 2021</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
